import { render, staticRenderFns } from "./administration.vue?vue&type=template&id=e3c1787c&"
import script from "./administration.vue?vue&type=script&lang=js&"
export * from "./administration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports